import { render, staticRenderFns } from "./section-user-info.vue?vue&type=template&id=796e5dd0&scoped=true"
import script from "./section-user-info.vue?vue&type=script&lang=js"
export * from "./section-user-info.vue?vue&type=script&lang=js"
import style0 from "./section-user-info.vue?vue&type=style&index=0&id=796e5dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e5dd0",
  null
  
)

export default component.exports